export const SIGNAL = {
  green: "#6B3FA0",
  yellow: "#A8865E",
  red: "#FCC83D",
};

export const SIGNAL_TEXT = {
  green: "#9B7BD1",
  yellow: "#C9A67A",
  red: "#FCC83D",
};

export const SIGNAL_WORD = {
  green: "Purple",
  yellow: "Purple-yellow",
  red: "Yellow",
};

export const Sticker = ({ state = "red", className = "", style, eager = false, testId = "sticker" }) => (
  <div className={`sticker ${className}`} style={style} data-testid={testId} data-state={state}>
    <img
      src="/assets/sticker.webp"
      alt="Telltag freshness indicator"
      loading={eager ? "eager" : "lazy"}
      decoding="async"
    />
    <span className="sticker-dot" data-testid={`${testId}-dot`} style={{ background: SIGNAL[state] ?? SIGNAL.red, opacity: 1 }} />
  </div>
);
